export async function updateUserInfo({commit}, payload) {
  const {errResponse, data: responseData} = await this.$frontendRepositories.users.update(payload, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });

  if (!errResponse && responseData.success) {
    commit('frontend/auth/setUser', responseData.data, {root: true});

    return responseData;
  }

  return Promise.reject(responseData.data);
}

export async function getCategory({commit}) {
  return this.$frontendRepositories.users.getCategory();
}

export async function getParentGroups() {
  return this.$frontendRepositories.users.getParentGroups();
}

export async function getUserNotInvitedInGroup(_, groupId) {
  return this.$frontendRepositories.users.getUserNotInvitedInGroup(groupId);
}

export async function inviteUser({commit}, payload) {
  commit('setBtnLoading', true, {root: true});
  const response = await this.$frontendRepositories.users.invite(payload);
  commit('setBtnLoading', false, {root: true});
  return response;
}

export function getEmployee(_, payload) {
  return this.$frontendRepositories.users.list(payload);
}

export async function getAllActiveUser({commit}, payload = {}) {
  const response = await this.$frontendRepositories.users.getAllActiveUser(payload);
  const {errResponse, data: dataResponse} = response;

  if(!errResponse) {
    commit('setUsers', dataResponse.data);
  }

  return response;
}

export async function updateFirstLoggedIn({commit}) {
  commit('frontend/auth/setFirstLogin', true, {root: true});
  await this.$frontendRepositories.users.updateFirstLoggedIn();
}

export function destroy(_, id) {
  return this.$frontendRepositories.users.delete(id);
}

export function getUser(_, id) {
  return this.$frontendRepositories.users.show(id);
}

export async function updateUserGroup(_, {id, groups}) {
  return await this.$frontendRepositories.users.updateUserGroup(id, {groups});
}

export async function beforeUpdateUserGroup(_, {id, groups}) {
  return await this.$frontendRepositories.users.beforeUpdateUserGroup(id, {groups});
}

export async function getActivities({commit}, page) {
  const {errResponse, data: responseData} = await this.$frontendRepositories.users.getActivities(page);
  if (!errResponse && responseData.success) {
    return commit('setActivities', responseData.data);
  }

  return [];
}

export async function getDashboardNotifications({commit}, page) {
  const {errResponse, data: responseData} = await this.$frontendRepositories.users.getDashBoardNotifications(page);
  if (!errResponse && responseData.success) {
    return commit('setDashboardNotifications', responseData.data);
  }

  return [];
}

export function clearBell({commit}) {
  return commit('clearBell');
}

export async function getBellNotifications({commit}, time) {
  const {errResponse, data: responseData} = await this.$frontendRepositories.users.getBellNotifications(time);
  if (!errResponse && responseData.success) {
    return commit('loadBellNotifications', responseData.data);
  }

  return [];
}

export async function fetchBellNotifications({commit}, time) {
  const {errResponse, data: responseData} = await this.$frontendRepositories.users.fetchBellNotifications(time);
  if (!errResponse && responseData.success) {
    return commit('fetchBellNotifications', responseData.data);
  }

  return [];
}

export async function readNotification({commit}, id) {
  commit('setBtnLoading', true, {root: true});
  const {errResponse, data: responseData} = await this.$frontendRepositories.users.readNotification(id);
  commit('setBtnLoading', false, {root: true});
  if (!errResponse && responseData.success) {
    return commit('readBellNotification', responseData.data);
  }
}

export async function sendMailExpiredPlan() {
  await this.$frontendRepositories.users.sendMailExpiredPlan();
}

export async function getInvalidGroup(_, payload) {
  const responseData = await this.$frontendRepositories.users.getInvalidGroup(payload);

  return responseData.data
}

export async function syncCalendarForCompany(_) {
  await this.$frontendRepositories.users.syncCalendarForCompany();
}